import React, { useEffect, Fragment, useState } from "react"
import { Container, Table } from "react-bootstrap"
import NavBarUser from "../../components/shared/NavBarUser"
import { withRouter, Link } from "react-router-dom"
import { getUnidadesAdmin, getTiposUnidad, deleteUnidad } from "../../services/admin.service.js"
import Loader from "../../components/shared/Loader"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { toast } from "react-toastify"
import ModalFormUnidad from "../../components/admin/ModalFormUnidad"

const AdminUnidades = () => {
	const [unidades, setUnidades] = useState([])
	const [tiposUnidad, setTiposUnidad] = useState([])
	const [loader, setLoader] = useState()
	const [showModal, setShowModal] = useState(false)
	const [unidadSelected, setUnidadSelected] = useState({})
	const [loaderDelete, setLoaderDelete] = useState(false)
	const [isEdit, setIsEdit] = useState(false)

	const openModalUnidad = () => {
		console.log("Abriendo modal unidad")
		setUnidadSelected({})
		setIsEdit(false)
		setShowModal(true)
	}

	const openModalUnidadEdit = unidad => {
		setIsEdit(true)
		setUnidadSelected(unidad)
		setShowModal(true)
	}

	const getUnidades = async () => {
		setLoader(true)
		const res = await getUnidadesAdmin()
		console.log(res)
		setUnidades(res.data)
		setLoader(false)
	}

	const getTipos = async () => {
		const res = await getTiposUnidad()
		console.log(res)
		if (res?.response === "success") {
			setTiposUnidad(res.data)
		} else {
			toast.error(res?.message || "No se han cargado correctamente los tipos de unidad")
		}
	}

	const confirmDelete = uni => {
		var conf = window.confirm("¿Confirma que desea eliminar esta unidad?")
		if (conf === true) {
			removeUnidad(uni)
		}
	}

	const removeUnidad = async uni => {
		setLoaderDelete(true)
		const res = await deleteUnidad(uni.id)
		if (res?.response === "success") {
			const newArray = unidades.filter(x => x.id !== uni.id)
			setUnidades(newArray)
			toast.info("Unidad eliminada correctamente")
		} else {
			toast.error(res?.message || "Se ha producido un error al eliminar")
		}
		setLoaderDelete(false)
	}

	useEffect(() => {
		if (unidades) {
			getTipos()
			getUnidades()
		}
	}, [])

	return (
		<Fragment>
			<NavBarUser />
			<Container className="mt-4">
				<h1>Unidades</h1>
				{loader ? (
					<Loader />
				) : (
					<Table bordered responsive>
						<thead>
							<tr>
								<th>N°</th>
								<th>COD</th>
								<th>Nombre</th>
								<th>Tipo</th>
								<th colSpan="2">Acciones</th>
							</tr>
						</thead>
						<tbody>
							{unidades.map((unidad, index) => {
								return (
									<tr key={index}>
										<td>{index + 1}</td>
										<td>{unidad.cod}</td>
										<td>{unidad.nombre}</td>
										<td>{unidad.tipo_unidad?.nombre}</td>

										<td className="text-center">
											<span
												className="text-primary a-link"
												onClick={() => openModalUnidadEdit(unidad)}
											>
												<FontAwesomeIcon icon="edit" size="2x" />
											</span>
										</td>
										<td className="text-center">
											<span
												className="text-danger a-link"
												onClick={() => confirmDelete(unidad)}
											>
												<FontAwesomeIcon icon="trash" size="2x" />
											</span>
										</td>
									</tr>
								)
							})}
						</tbody>
					</Table>
				)}
				<hr />
				{loaderDelete ? (
					<Loader />
				) : (
					<Link className="btn btn-success" onClick={() => openModalUnidad()}>
						<FontAwesomeIcon icon="plus" className="mr-2" />
						Nueva Unidad
					</Link>
				)}
			</Container>
			<ModalFormUnidad
				show={showModal}
				setShow={setShowModal}
				tipos={tiposUnidad}
				setUnidades={setUnidades}
				unidad={unidadSelected}
				isEdit={isEdit}
			/>
		</Fragment>
	)
}

export default withRouter(AdminUnidades)
